"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  name: "zone1",
  level: 1,
  soldiers: { "swarmling-queen": 1 }
}, {
  name: "zone2",
  level: 2,
  soldiers: { "swarmling-queen": 1e1 }
}, {
  name: "zone3",
  level: 3,
  soldiers: { "swarmling-queen": 1e3 }
}, {
  name: "zone4",
  level: 4,
  soldiers: { "swarmling-queen": 1e5 }
}, {
  name: "zone5",
  level: 5,
  soldiers: { "swarmling-queen": 1e7 }
}, {
  name: "zone6",
  level: 6,
  soldiers: { "swarmling-queen": 1e7, "overlord-den": 10 }
}, {
  name: "zone7",
  level: 7,
  soldiers: { "swarmling-queen": 1e9, "overlord-den": 1e4 }
}, {
  name: "zone8",
  level: 8,
  soldiers: { "swarmling-queen": 1e11, "overlord-den": 1e6 }
}, {
  name: "zone9",
  level: 9,
  soldiers: { "swarmling-queen": 1e14, "overlord-den": 1e9 }
}];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/entities2/zone-types/json.js
// module id = 780
// module chunks = 0